import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

// TODO: how long are we going to keep supporting tab?
// At some point we should remove it.
const pipelinesSchema = z.object({
  tab: z.string().optional().catch(undefined),
});

export type SearchSchema = z.infer<typeof pipelinesSchema>;

export const Route = createFileRoute('/_private/_route/_internal/pipelines')({
  beforeLoad: ({ search }) => {
    // If tab has any other value, just go to index.
    // Cancels out search filters in order to default
    // to created, the default sort.
    if (search.tab) {
      throw redirect({
        replace: true,
        search: {
          order: 'desc',
          sort: 'created',
          status: ['active'],
        },
        to: '/pipelines',
      });
    }
  },
  validateSearch: pipelinesSchema,
});
